(() => {
  const root = document.querySelector('[data-ab-catalog]');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const labels = JSON.parse(root.querySelector('[data-ab-labels]').textContent);
  const cards = [...root.querySelectorAll('.ab-auction-card')];
  const params = new URLSearchParams(location.search);
  let sale = ['auction', 'buy'].includes(params.get('sale')) ? params.get('sale') : 'all';
  let category = params.get('category') || root.dataset.category || 'all';
  let ready = false;
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:root.dataset.currency, currencyDisplay:'code'}).format(value);
  const setText = (card, selector, value) => { const el = card.querySelector(selector); if (el && el.textContent !== value) el.textContent = value; };
  const utc = value => Date.parse(/(?:Z|[+-]\d\d:\d\d)$/.test(value || '') ? value : `${String(value || '').replace(' ', 'T')}Z`);
  const match = (profile, card) => {
    const rule = profile?.config?.rule;
    if (rule?.manual?.enabled) return rule.manual.ids?.some(id => String(id) === card.dataset.productId);
    if (rule?.collections?.enabled) return rule.collections.ids?.some(id => JSON.parse(card.dataset.collections).map(String).includes(String(id)));
    return !!rule?.all?.enabled;
  };
  function filter(updateUrl = false) {
    let count = 0;
    cards.forEach(card => {
      const categoryMatch = category === 'all' || JSON.parse(card.dataset.tags).includes(category);
      card.hidden = !categoryMatch || (sale !== 'all' && card.dataset.sale !== sale);
      if (!card.hidden) count++;
    });
    root.querySelectorAll('[data-sale-filter]').forEach(button => {
      const value = button.dataset.saleFilter;
      const number = cards.filter(card => (category === 'all' || JSON.parse(card.dataset.tags).includes(category)) && (value === 'all' || card.dataset.sale === value)).length;
      button.setAttribute('aria-pressed', String(value === sale));
      button.querySelector('span').textContent = ready || value === 'all' ? number : '…';
    });
    root.querySelectorAll('[data-category-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.categoryFilter === category)));
    root.querySelector('[data-ab-count]').textContent = !ready && sale !== 'all' ? labels.checking : (count === 1 ? labels.one_item : labels.item_count.replace('[count]', count));
    root.querySelector('[data-ab-empty]').hidden = count > 0 || !ready;
    if (updateUrl) {
      const url = new URL(location.href);
      url.pathname = root.dataset.url;
      sale === 'all' ? url.searchParams.delete('sale') : url.searchParams.set('sale', sale);
      category === 'all' ? url.searchParams.delete('category') : url.searchParams.set('category', category);
      history.replaceState(null, '', url);
    }
  }
  function sort() {
    const mode = root.querySelector('[data-ab-sort]').value;
    [...cards].sort((a,b) => {
      if (a.dataset.available !== b.dataset.available) return a.dataset.available === 'true' ? -1 : 1;
      if (mode === 'price-up') return Number(a.dataset.sortPrice) - Number(b.dataset.sortPrice);
      if (mode === 'price-down') return Number(b.dataset.sortPrice) - Number(a.dataset.sortPrice);
      if (mode === 'title') return a.dataset.title.localeCompare(b.dataset.title);
      return Number(a.dataset.order) - Number(b.dataset.order);
    }).forEach(card => root.querySelector('[data-ab-grid]').append(card));
  }
  function refresh() {
    const app = window.Tipo?.Auction;
    if (!Array.isArray(app?.auctions)) return;
    ready = true;
    cards.forEach(card => {
      const context = app.auctionContexts?.[card.dataset.productId];
      const profile = context?.profile || app.auctions.find(profile => match(profile, card));
      card.dataset.sale = profile ? 'auction' : 'buy';
      setText(card, '[data-ab-sale-label]', profile ? labels.auction : labels.buy_now);
      if (!profile) return;
      if (!context?.summary) {
        setText(card, '[data-ab-bid]', labels.view_bid);
        return;
      }
      const summary = context.summary;
      const now = Date.now();
      const start = utc(profile.start_at);
      const end = utc(summary.popcorn_end_at || profile.end_at);
      const ended = !!summary.winnerAuction || (profile.fired_end_at != null && profile.fired_end_at !== 0 && profile.fired_end_at !== '0') || now >= end || context.stopped;
      const pending = !ended && now < start;
      const current = Number(summary.currentAmount);
      const initial = profile.config.startPriceUnit === 'percentage' ? Math.ceil(Number(context.product.variants[0].price) * Number(profile.config.startPrice) / 100) : Number(profile.config.startPrice);
      const amount = current > 0 ? current : initial;
      const label = ended && current > 0 ? labels.final_bid : current > 0 ? labels.current_bid : labels.starting_bid;
      setText(card, '[data-ab-bid]', Number.isFinite(amount) ? `${label}: ${money(amount)}` : labels.view_bid);
      card.dataset.sortPrice = Number.isFinite(amount) ? amount : card.dataset.price;
      const count = Number(summary.counterBids || 0);
      setText(card, '[data-ab-bids]', count === 1 ? labels.one_bid : labels.bids.replace('[count]', count));
      let timing = labels.ended;
      if (!ended && Number.isFinite(end) && Number.isFinite(start)) {
        const minutes = Math.max(0, Math.ceil(((pending ? start : end) - now) / 60000));
        const days = Math.floor(minutes / 1440);
        const hours = Math.floor(minutes % 1440 / 60);
        const duration = `${days ? `${days}d ` : ''}${hours ? `${hours}h ` : ''}${minutes % 60}m`;
        timing = (pending ? labels.starts_in : labels.ends_in).replace('[time]', duration);
      }
      setText(card, '[data-ab-time]', timing);
      const buyout = profile.config.buyout;
      const buyEl = card.querySelector('[data-ab-buyout]');
      buyEl.hidden = !!ended || !!pending || !buyout?.enabled || !buyout?.display;
      if (!buyEl.hidden) setText(card, '[data-ab-buyout]', `${labels.buy_now}: ${money(Number(buyout.amount))}`);
      setText(card, '[data-ab-auction-link]', ended ? labels.view_result : labels.view_auction);
    });
    filter();
  }
  root.addEventListener('click', event => {
    const saleButton = event.target.closest('[data-sale-filter]');
    const categoryButton = event.target.closest('[data-category-filter]');
    if (saleButton) sale = saleButton.dataset.saleFilter;
    if (categoryButton) category = categoryButton.dataset.categoryFilter;
    if (saleButton || categoryButton) filter(true);
  });
  root.querySelector('[data-ab-sort]').addEventListener('change', sort);
  window.addEventListener('tipo.auction.collection.loaded', refresh);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
  filter();
  refresh();
  const interval = setInterval(() => {
    if (!root.isConnected) { clearInterval(interval); return; }
    if (!document.hidden) refresh();
  }, 1000);
})();
